module.exports = __webpack_public_path__ + "static/img/logo.5274e687.svg";